/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function() {
  var defer = $.Deferred();

  $.soap({
    body: {
      GetAllApplicationStatus: {
        $xmlns: 'http://dobs.pa.gov/nd/lookup/bpm/1.0'
      }
    },
    blueprintArrays: ['GetAllApplicationStatusResponse.ApplicationStatus.ND_LU_ApplicationStatus'],
    blueprint: {
      applicationStatus: [
        '$..ND_LU_ApplicationStatus',
        {
          id: '$.ID',
          internalStatus: '$.InternalStatus',
          externalStatus: '$.ExternalStatus',
          description: '$.Description'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      response.applicationStatus = _.filter(response.applicationStatus, function(status) {
        return status.internalStatus !== null;
      });
      defer.resolve(response.applicationStatus);
    })
    .fail(function(err) {
      defer.reject(err);
    });

  return defer.promise();
};
